var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"small":"","color":_vm.chipColor,"dark":""}},[_vm._v(" "+_vm._s(_vm.statusLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }